
import LayoutBase from "@/common/LayoutBase"
import websiteConfig from "@/assets/json/config.json"
import { safeJsonLd } from "@/utils/jsonldSafe"

// Sitewide structured data. The previous jsonld() hook was dead code —
// the @nuxtjs/jsonld plugin isn't installed, so nothing read it. This
// emits the same intent via vue-meta head(), which IS wired up.
// Pages can override either entry by reusing the same hid.
const ORIGIN = `https://${websiteConfig.domain}`

// Organization is emitted on the homepage only — it identifies the site as a
// whole, and Google expects one per site rather than one per page. telephone
// and email sit inside contactPoint rather than being duplicated at top level.
// memberOf matters most here: third-party association membership is a
// verifiable authority signal for both Google and AI search engines.
const ORGANIZATION = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: websiteConfig.name,
  alternateName: "Dundalk LeisureCraft",
  legalName: "Dundalk LeisureCraft Inc.",
  url: ORIGIN,
  logo: `${ORIGIN}/images/leisurecraft-logo-full.png`,
  description:
    "Canadian manufacturer of outdoor saunas, cold plunges, hot tubs and outdoor showers, handcrafted in Melancthon, Ontario since 2004 and sold through authorized dealers across North America and Europe.",
  foundingDate: "2004",
  address: {
    "@type": "PostalAddress",
    streetAddress: "318448 8th Line NE",
    addressLocality: "Melancthon",
    addressRegion: "ON",
    postalCode: "L9V 2K3",
    addressCountry: "CA",
  },
  contactPoint: {
    "@type": "ContactPoint",
    contactType: "customer service",
    // config phone is already "1-888-923-9813" — only the "+" is missing.
    telephone: `+${websiteConfig.phone}`,
    email: websiteConfig.email,
    contactOption: "TollFree",
    areaServed: ["CA", "US"],
    availableLanguage: ["en"],
  },
  areaServed: ["Canada", "United States", "Europe", "Brazil", "Israel", "New Zealand", "Australia"],
  memberOf: [
    { "@type": "Organization", name: "World Sauna Forum", url: "https://worldsaunaforum.com/" },
    { "@type": "Organization", name: "West Coast Sauna Summit", url: "https://www.westcoastsaunasummit.ca" },
    { "@type": "Organization", name: "North American Sauna Society", url: "https://www.saunasociety.org/" },
    { "@type": "Organization", name: "Western Red Cedar Lumber Association", url: "https://www.realcedar.com/" },
    { "@type": "Organization", name: "Ontario Wood Association", url: "https://www.ontario.ca/page/ontario-wood" },
  ],
  sameAs: Object.values(websiteConfig.socials),
}

const WEBSITE = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  name: websiteConfig.name,
  url: ORIGIN,
}

export default {
  extends: LayoutBase,

  head() {
    const script = [
      {
        hid: "jsonld-website",
        type: "application/ld+json",
        innerHTML: safeJsonLd(WEBSITE),
      },
    ]

    if (this.$route.path === "/") {
      script.unshift({
        hid: "jsonld-organization",
        type: "application/ld+json",
        innerHTML: safeJsonLd(ORGANIZATION),
      })
    }

    return {
      script,
      __dangerouslyDisableSanitizers: ["script"],
    }
  },
}
